module.exports = __webpack_public_path__ + "img/service-01-pic-1.e79d4861.png";